<script setup lang="ts">
/**
 * Paid-traffic entry point: one job, build a CV and leave with a PDF — by
 * chatting with the AI, pasting the text, or the classic form, as on the
 * homepage hero. Framed by the same header and footer as the rest of the site.
 */
definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/zivotopis-zdarma', de: '/lebenslauf-kostenlos', pl: '/kreator-cv-za-darmo' } })

const { t } = useI18n()
const { isAuthenticated } = useAuthUser()

useSeoMeta({
  title: () => t('landing.builder.seo.title'),
  description: () => t('landing.builder.seo.description'),
  ogTitle: () => t('landing.builder.seo.title'),
  ogDescription: () => t('landing.builder.seo.description'),
  robots: 'index, follow',
})
</script>

<template>
  <NuxtLayout name="sell" :show-back-button="false">
    <div class="w-full bg-white dark:bg-gray-950">
      <!-- Same hero as the homepage: chat with the AI, paste the text, or the form -->
      <LandingCvCreateModes chat-source="free-cv-builder-chat" paste-source="free-cv-builder" with-steps pricing-to="/pricing" />
    </div>

    <!-- The chat above, as a 30-second video -->
    <MarketingFeatureVideo video="chat" />

    <ClientOnly>
      <LazyCommonNewsletterDialog v-if="!isAuthenticated" source="download" />
    </ClientOnly>
  </NuxtLayout>
</template>
